export const createWidgetMQ = () => {
  // Internal state to store event listeners as key: value pairs
  let listeners = {}

  // Subscribe to an event -> in widget or parent
  const subscribe = (eventName, callback, id) => {
    if (!listeners[eventName]) {
      listeners[eventName] = []
    }
    if (listeners[eventName].some(clbObject => clbObject.id === id)) {
      unsubscribe(eventName, id)
    }
    listeners[eventName].push({
      id,
      callback
    })
  }

  // Publish an event -> from widget or parent
  const publish = (eventName, data) => {
    const eventListeners = listeners[eventName]

    if (eventListeners) {
      eventListeners.forEach(clbObject => {
        clbObject.callback(data)
      })
    }
  }

  // Unsubscribe from an event -> in beforeUnmount of each component which is subscribed
  const unsubscribe = (eventName, id) => {
    const eventListeners = listeners[eventName]

    if (eventListeners) {
      listeners[eventName] = eventListeners.filter(clbObject => clbObject.id !== id)
    }
  }

  const close = () => {
    listeners = {}
  }

  // Return the public interface
  return {
    subscribe,
    publish,
    unsubscribe,
    close
  }
}

export const WidgetMQ = createWidgetMQ()

export const WidgetMQEvents = {
  RCU_KEY: 'RCU_KEY',
  WIDGET_THEME: 'WIDGET_THEME',
  WIDGET_SIZE: 'WIDGET_SIZE',
  WIDGET_HEIGHT: 'WIDGET_HEIGHT',
  TABS_REORDER: 'TABS_REORDER'
}
